import React from 'react';
import MissingPoster from '@/components/_common/MissingPoster';
import styled from '@emotion/styled';
import { Box, BoxProps, Fade, Skeleton, Typography } from '@mui/material';

type PostProps = Omit<BoxProps, 'title'> & {
  loading?: boolean;
  src?: string;
  title?: React.ReactNode;
  maxWidth?: 'none' | number;
};

const Poster: React.FC<PostProps> = ({ loading = false, src, title = '', maxWidth = 'none', ...props }) => {
  return (
    <Fade in timeout={600}>
      <PosterBox style={{ backgroundImage: `url(${src})`, maxWidth }} {...props}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height="100%" />
        ) : (
          !src && (
            <>
              <StyledMissingPoster />
              <ImageTitle variant="h2">{title}</ImageTitle>
            </>
          )
        )}
      </PosterBox>
    </Fade>
  );
};

export default Poster;

const PosterBox = styled(Box)`
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.action.hover};
  background-image: none;
  aspect-ratio: 2 / 3;
  position: relative;
  background-size: cover;
  border: 1px solid ${({ theme }) => theme.palette.primary.main + '4a'};
`;

const ImageTitle = styled(Typography)`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-start;
  font-weight: ${({ theme }) => theme.typography.fontWeightLight};
  padding: ${({ theme }) => theme.spacing(4)};
`;

const StyledMissingPoster = styled(MissingPoster)`
  position: absolute;
`;
